import { ApprovalTaskStatues } from "common";

export const approvalTaskStatuesOption = [
  {
    value: ApprovalTaskStatues.PENDING,
    label: "Submitted",
    data: { colorScheme: "yellow" },
  },
  {
    value: ApprovalTaskStatues.CHECKER_APPROVED,
    label: "Reviewed",
    data: { colorScheme: "gray" },
  },
  {
    value: ApprovalTaskStatues.CHECKER_REJECTED,
    label: "Rejected by Checker",
    data: { colorScheme: "red" },
  },
  {
    value: ApprovalTaskStatues.APPROVER_APPROVED,
    label: "Approved",
    data: { colorScheme: "blue" },
  },
  {
    value: ApprovalTaskStatues.APPROVER_DISAPPROVED,
    label: "Disapproved by Approver",
    data: { colorScheme: "red" },
  },
  {
    value: ApprovalTaskStatues.APPROVED,
    label: "Processed by GoTyme Ops Team",
    data: { colorScheme: "green" },
  },
  {
    value: ApprovalTaskStatues.PAYMENT_OPS_DECLINED,
    label: "Declined by GoTyme Ops Team",
    data: { colorScheme: "red" },
  },
  {
    value: ApprovalTaskStatues.PROCESSING,
    label: "Processing",
    data: { colorScheme: "green" },
  },
  {
    value: ApprovalTaskStatues.REJECTED,
    label: "Rejected",
    data: { colorScheme: "red" },
  },
];
